export const arr1 = [
  { text: 'Частота дискретизации может отличаться. Это имеет очень большое значение, и сейчас ты сможешь понять, почему.' },
  { text: 'Оцифровали одну и ту же мелодию с разной частотой дискретизации.' },
  { text: 'Задание: выбери, качество звука какого варианта оцифровки будет выше. Ты сможешь прослушать их и оценить разницу.', buttonTitle: 'Продолжить' },
]

export const arr2 = [
  { text: 'Правильно. Чем выше частота дискретизации, тем выше качество оцифровки.', buttonTitle: 'Продолжить' },
]

export const hint = [
  { text: 'Точно? Ты хорошо подумал?' },
]

export const task = [
  { text: 'Задание: выбери, качество звука какого варианта оцифровки будет выше. Ты сможешь прослушать их и оценить разницу.' },
]
